import { LanguageEntries } from './LanguageEntries';
import { LanguageContext } from './LanguageContext';

export const translator = (key: keyof LanguageEntries): string => {
  const lng: LanguageEntries = {
    no: 'No',
    yes: 'Yes',
    german: 'German',
    english: 'English',
    selectLanguage: 'Select language…',
    pleaseSelect: 'Please Select…',
    mr: 'Mr.',
    mrs: 'Mrs.',
    clear: 'Clear',
    cancel: 'Cancel',
    missing: 'Missing',
    expiryError: 'The identification document must still be valid for at least three months',
    expiryInfo: "<p>The identification document must be valid for at least three months from today's date.</p>",
    invalidNumber: 'Invalid number',
    invalidDate: 'Invalid date',
    confirm: 'Confirm',
    disclosureTitle: 'Self-disclosure',

    yesUsCitizen: 'Yes, US citizen',
    noUsCitizen: 'No, not an US citizen',
    fatcaInfo: `
   <p>I am not a US citizen. Because of the FATCA-Regulation (Foreign Account Tax Compliance Act) we have to question
    whether or not our customers have a tax liability with the United States.
   </p>
   <p>A US person is defined as:</p>
<ol>
<li>US citizen (as well as Dual-Citizenship) </li>
<li>Residence in the US (US resident alien, i.e. Greencard or substantial presence, see also: 
<a href="https://www.irs.gov/individuals/international-taxpayers/determining-alien-tax-status">
https://www.irs.gov/individuals/international-taxpayers/determining-alien-tax-status</a></li>
<li>Born in the USA/US territory</li>
<li>Other reasons for being liable to pay taxes in the US (i.e. double residency, joint tax return with a US person)</li>
</ol>

`,
    title: 'Salutation',
    name: 'Name',
    firstName: 'First name',
    lastName: 'Last name',
    street: 'Street',
    housenumber: 'House No.',
    zipCode: 'Zip code',
    city: 'City',
    partner1RegisterAddress: 'Country of address',
    mail: 'E-Mail',
    phonenumber: 'Telephone number',
    partner1MaritalStatus: 'Marital status',
    disclosureHeaderPersonalData: 'Personal disclosure',
    germany: 'Germany',
    notGermany: 'Not Germany',
    partner1NoUSCitizen: 'Signer is a US citizen',
    maritalSingle: 'Single',
    maritalMarried: 'Married',
    maritalParted: 'Separated',
    maritalWidowed: 'Widow',
    maritalDivorced: 'Divorced',
    maritalDivorcedNoAlimony: 'Divorced without alimony obligation',
    maritalPartnership: 'Partnership',
    maritalRegisteredLifePartnership: 'Registered life partnership',
    identityCardDataTitle: 'Contractor ID',
    identityCardType: 'Type of ID card',
    identityCardNumber: 'ID card number',
    identityCardPlaceOfIssue: 'ID place of issue',
    identityCardIssueAgency: 'ID authority of issue',
    identityCardDateOfIssue: 'ID date of issue',
    identityCardDateOfExpire: 'ID card expiration date',
    dateOfBirth: 'Date of birth',
    placeOfBirth: 'Place of birth',
    cardTypeGermanIdentityCard: 'German ID card',
    cardTypeGermanPassport: 'German passport',
    cardTypeEUIdentityCard: 'EU ID card',
    cardTypeEUPassport: 'EU passport',
    cardTypeOtherPassport: 'Other passports',
    budgetTitle: 'Budget',
    budgetAlimonyPersonCount: 'Number of persons receiving alimony from you',
    budgetAlimonyChildrenCount: 'Children receiving alimony from you',
    budgetJobType: 'Job description',
    budgetProbationaryPeriod: 'Probationary period',
    budgetFixedTermEmploymentContract: 'Fixed term employment contract',
    budgetEmploymentContractEndStamp: 'End of contract',
    budgetNetIncome: 'Net income per month',
    budgetAdditionalIncome: 'Additional income per month',
    budgetQualityQuestion1: 'Hereby, I assure you that the money is being used for private consumption.',
    budgetQualityQuestion2:
      'Hereby, I assure you that there are no insolvency proceedings, enforcement measures, such as repossessions,  ' +
      'wage garnishments, being taken upon me and that I have not given any affidavit on my private status ' +
      'and economic circumstances.',
    budgetQualityQuestion3:
      'Hereby, I confirm that to the best of my knowledge, all the above and attached declarations are ' +
      'complete and correct.',
    jobTypeEmployee: 'Employee',
    jobTypeWorker: 'Worker',
    jobTypeFreelancer: 'Freelancer ',
    jobTypeSelfEmployed: 'Self-employed',
    jobTypeClerk: 'Clerk',
    jobTypePensioner: 'Pensioner',
    jobTypeUnemployed: 'Unemployed',
    jobTypePupil: 'Pupil',
    jobTypeStudent: 'Student ',
    jobTypeApprentice: 'Apprentice',
    jobTypeAtHome: 'Housemaker',
    jobTypeWithoutJob: 'Without job',
    jobTypeIndependent: 'Independent',
    bankSectionTitle: 'Bank account information',
    bankAccountOwner: 'Account owner',
    iban: 'IBAN',
    euCountryBelgium: 'Belgium',
    euCountryBulgaria: 'Bulgaria',
    euCountryDenmark: 'Denmark',
    euCountryGermany: 'Germany',
    euCountryEstonia: 'Estonia',
    euCountryFinland: 'Finland',
    euCountryFrance: 'France',
    euCountryGreece: 'Greece',
    euCountryNetherlands: 'Netherlands',
    euCountryItaly: 'Italy',
    euCountryIreland: 'Ireland',
    euCountryCroatia: 'Croatia',
    euCountryLatvia: 'Latvia',
    euCountryLithuania: 'Lithuania',
    euCountryLuxembourg: 'Luxembourg',
    euCountryMalta: 'Malta',
    euCountryAustria: 'Austria',
    euCountryPoland: 'Poland',
    euCountryPortugal: 'Portugal',
    euCountryRomania: 'Romania',
    euCountrySweden: 'Sweden',
    euCountrySlovakia: 'Slovakia',
    euCountrySlovenia: 'Slovenia',
    euCountrySpain: 'Spain',
    euCountryCzech: 'Czechia',
    euCountryHungary: 'Hungary ',
    euCountryCyprus: 'Cyprus',

    close: 'Close',
    error: 'Error',

    partner1Nationality: 'Nationality',
    partner1CountryOfBirth: 'country of birth',
    errorPleaseContact: 'Please contact the fintechOne customer service',
    unknownLoadError: 'The data could not be loaded. Please try again later!',
    forbiddenLoadError: 'The self-inquiry requested by you has already been completed.',
    notFoundLoadError: 'The requested self-report could not be found',
    submitErrorDialogTitle: 'transmission error',
    submitErrorDialogText: 'The data could not be transmitted. Please try again later.',
    contactCustomerService: 'Customer Service Center',
    contactSupportNumber: '0800 800 00 12',
    contactCallbackService: 'Contact / Call Back Service',
    contactSupportChat: 'consultant Chat',
    contactMailAddress: 'info@fintechone.de',
    contactCompanyName: 'fintechOne mobility gmbh',
    contactAddress: 'Würmstrasse 55',
    contactZipCodeCity: '82166 München-Gräfelfing',
    contactCountry: 'Germany',
    disclosureWelcomeText: 'For the execution of your contract we still need a few details:',
    disclosureSubmitButtonText: 'Provide self-assessment',
    disclosureSuccessTitle: 'Many Thanks! Your data has been transmitted securely.',
    disclosureSuccessText:
      '<p> We are almost done! <br/> <br/> As a final step, we still need your legitimacy. ' +
      'Please follow the instructions in the email. </p>',
    inspectionPageTitle: 'Additional information',
    inspectionWelcomeTextHuesges:
      '<p> Dear Customer, </p><p>You have opted for the option of preparing a report' +
      ' at your home or at a location of your choice, and thus therefore a time and cost saving solution. ' +
      'Trips to inspection stations or remote offices are no longer necessary, we come to you!</p>' +
      '<p>Please enter your contact details below so that the appraiser can call you and arrange an appointment ' +
      'with you at a location of your choice.</p>',
    inspectionContactDataTitle: 'contact details',
    inspectionVehicleDataTitle: 'vehicle data',
    inspectionVehicleFinLabel: 'VIN',
    inspectionVehicleLicensePlateLabel: 'License plate',
    inspectionVehicleManufacturerLabel: 'Manufacturer',
    inspectionVehicleModelLabel: 'model',
    inspectionVehicleMileage: 'Mileage',
    inspectionVehicleRegistrationDate: 'Registration Date',
    inspectionAlternativeTitle: 'Different place of visit',
    inspectionSuccessTitle: 'Successfully applied',
    inspectionSuccessText: `<p>Dear Customer,</p>
<p>Thank you.</p>
<p>
  Your appraiser will contact you. <br />
  <br />
  We look forward to working with you. <br />
  <br/>
  Best regards, <br />
  <br />
  Team Customer Service <br />
</p>
<p>
\t<strong>Hint:</strong>&nbsp;a car that is clean from the outside and the inside leaves a better impression.
</p>`,
    inspectionLoadNotFoundError: 'The data could not be loaded. Please try again later!',
    inspectionLoadForbiddenError: 'The requested report has already been filled out.',
    inspectionLoadUnknownError: 'The report request requested by you could not be found',
    inspectionVehicleRegistrationDateTooOld: 'Die Erstzulassung ist zu lange her.',
    inspectionVehicleMileageTooHigh: 'Die maximale Laufleistung ist bereits erreicht',

    countryDE: 'Germany',
    countryFR: 'France',
    countryNL: 'Netherlands',
    countryIT: 'Italy',
    countryIE: 'Ireland',
    countryDK: 'Denmark',
    countryGR: 'Greece',
    countryPT: 'Portugal',
    countryES: 'Spain',
    countryBE: 'Belgium',
    countryLU: 'Luxembourg',
    countryIS: 'Iceland',
    countryNO: 'Norway',
    countrySE: 'Sweden',
    countryFI: 'Finland',
    countryLI: 'Liechtenstein',
    countryAT: 'Austria',
    countryCH: 'Switzerland',
    countryFO: 'Faroe Islands',
    countryAD: 'Andorra',
    countryGI: 'Gibraltar',
    countryVA: 'Holy See',
    countryMT: 'Malta',
    countrySM: 'San Marino',
    countryTR: 'Turkey',
    countryEE: 'Estonia',
    countryLV: 'Latvia',
    countryLT: 'Lithuania',
    countryPL: 'Poland',
    countryCZ: 'Czechia',
    countrySK: 'Slovakia',
    countryHU: 'Hungary',
    countryRO: 'Romania',
    countryBG: 'Bulgaria',
    countryAL: 'Albania',
    countryUA: 'Ukraine',
    countryBY: 'Belarus',
    countryMD: 'Moldova (Republic of)',
    countryRU: 'Russian Federation',
    countryGE: 'Georgia',
    countryAM: 'Armenia',
    countryAZ: 'Azerbaijan',
    countryKZ: 'Kazakhstan',
    countryTM: 'Turkmenistan',
    countryUZ: 'Uzbekistan',
    countryTJ: 'Tajikistan',
    countryKG: 'Kyrgyzstan',
    countrySI: 'Slovenia',
    countryHR: 'Croatia',
    countryBA: 'Bosnia and Herzegovina',
    countryMK: 'Macedonia (the former Yugoslav Republic of)',
    countryME: 'Montenegro',
    countryRS: 'Serbia',
    countryU1: 'United Kingdom',
    countryGG: 'Guernsey',
    countryJE: 'Jersey',
    countryIM: 'Isle of Man',
    countryMA: 'Morocco',
    countryDZ: 'Algeria',
    countryTN: 'Tunisia',
    countryLY: 'Libya',
    countryEG: 'Egypt',
    countrySD: 'Sudan',
    countrySS: 'South Sudan',
    countryMR: 'Mauritania',
    countryML: 'Mali',
    countryBF: 'Burkina Faso',
    countryNE: 'Niger',
    countryTD: 'Chad',
    countryCV: 'Cabo Verde',
    countrySN: 'Senegal',
    countryGM: 'Gambia',
    countryGW: 'Guinea-Bissau',
    countryGN: 'Guinea',
    countrySL: 'Sierra Leone',
    countryLR: 'Liberia',
    countryCI: 'Côte d Ivoire',
    countryGH: 'Ghana',
    countryTG: 'Togo',
    countryBJ: 'Benin',
    countryNG: 'Nigeria',
    countryCM: 'Cameroon',
    countryCF: 'Central African Republic',
    countryGQ: 'Equatorial Guinea',
    countryST: 'Sao Tome and Principe',
    countryGA: 'Gabon',
    countryCG: 'Congo',
    countryCD: 'Congo (Democratic Republic of the)',
    countryRW: 'Rwanda',
    countryBI: 'Burundi',
    countrySH: 'Saint Helena, Ascension and Tristan da Cunha',
    countryAO: 'Angola',
    countryET: 'Ethiopia',
    countryER: 'Eritrea',
    countryDJ: 'Djibouti',
    countrySO: 'Somalia',
    countryKE: 'Kenya',
    countryUG: 'Uganda',
    countryTZ: 'Tanzania, United Republic of',
    countrySC: 'Seychelles',
    countryIO: 'British Indian Ocean Territory',
    countryMZ: 'Mozambique',
    countryMG: 'Madagascar',
    countryMU: 'Mauritius',
    countryKM: 'Comoros',
    countryYT: 'Mayotte',
    countryZM: 'Zambia',
    countryMW: 'Malawi',
    countryZA: 'South Africa',
    countryNA: 'Namibia',
    countryBW: 'Botswana',
    countrySZ: 'Eswatini',
    countryLS: 'Lesotho',
    countryUS: 'United States of America',
    countryCA: 'Canada',
    countryGL: 'Greenland',
    countryPM: 'Saint Pierre and Miquelon',
    countryMX: 'Mexico',
    countryBM: 'Bermuda',
    countryGT: 'Guatemala',
    countryBZ: 'Belize',
    countryHN: 'Honduras',
    countrySV: 'El Salvador',
    countryNI: 'Nicaragua',
    countryCR: 'Costa Rica',
    countryPA: 'Panama',
    countryAI: 'Anguilla',
    countryCU: 'Cuba',
    countryKN: 'Saint Kitts and Nevis',
    countryHT: 'Haiti',
    countryBS: 'Bahamas',
    countryTC: 'Turks and Caicos Islands',
    countryDO: 'Dominican Republic',
    countryVI: 'Virgin Islands (U.S.)',
    countryAG: 'Antigua and Barbuda',
    countryDM: 'Dominica',
    countryKY: 'Cayman Islands',
    countryJM: 'Jamaica',
    countryLC: 'Saint Lucia',
    countryVC: 'Saint Vincent and the Grenadines',
    countryVG: 'Virgin Islands (British)',
    countryBB: 'Barbados',
    countryMS: 'Montserrat',
    countryTT: 'Trinidad and Tobago',
    countryGD: 'Grenada',
    countryAW: 'Aruba',
    countryBQ: 'Bonaire, Sint Eustatius and Saba',
    countryCW: 'Curaçao',
    countrySX: 'Sint Maarten (Dutch part)',
    countryCO: 'Colombia',
    countryVE: 'Venezuela (Bolivarian Republic of)',
    countryGY: 'Guyana',
    countrySR: 'Suriname',
    countryEC: 'Ecuador',
    countryPE: 'Peru',
    countryBR: 'Brazil',
    countryCL: 'Chile',
    countryBO: 'Bolivia (Plurinational State of)',
    countryPY: 'Paraguay',
    countryUY: 'Uruguay',
    countryAR: 'Argentina',
    countryFK: 'Falkland Islands (Malvinas)',
    countryCY: 'Cyprus',
    countryLB: 'Lebanon',
    countrySY: 'Syrian Arab Republic',
    countryIQ: 'Iraq',
    countryIR: 'Iran (Islamic Republic of)',
    countryIL: 'Israel',
    countryPS: 'Palestine, State of',
    countryTL: 'Timor-Leste',
    countryJO: 'Jordan',
    countrySA: 'Saudi Arabia',
    countryKW: 'Kuwait',
    countryBH: 'Bahrain',
    countryQA: 'Qatar',
    countryAE: 'United Arab Emirates',
    countryOM: 'Oman',
    countryYE: 'Yemen',
    countryAF: 'Afghanistan',
    countryPK: 'Pakistan',
    countryIN: 'India',
    countryBD: 'Bangladesh',
    countryMV: 'Maldives',
    countryLK: 'Sri Lanka',
    countryNP: 'Nepal',
    countryBT: 'Bhutan',
    countryMM: 'Myanmar',
    countryTH: 'Thailand',
    countryLA: 'Lao Peoples Democratic Republic',
    countryVN: 'Viet Nam',
    countryKH: 'Cambodia',
    countryID: 'Indonesia',
    countryMY: 'Malaysia',
    countryBN: 'Brunei Darussalam',
    countrySG: 'Singapore',
    countryPH: 'Philippines',
    countryMN: 'Mongolia',
    countryCN: 'China',
    countryKP: 'Korea (Democratic Peoples Republic of)',
    countryKR: 'Korea (Republic of)',
    countryJP: 'Japan',
    countryTW: 'Taiwan, Province of China[a]',
    countryHK: 'Hong Kong',
    countryMO: 'Macao',
    countryAU: 'Australia',
    countryPG: 'Papua New Guinea',
    countryNR: 'Nauru',
    countryNZ: 'New Zealand',
    countrySB: 'Solomon Islands',
    countryTV: 'Tuvalu',
    countryNC: 'New Caledonia',
    countryWF: 'Wallis and Futuna',
    countryKI: 'Kiribati',
    countryPN: 'Pitcairn',
    countryFJ: 'Fiji',
    countryVU: 'Vanuatu',
    countryTO: 'Tonga',
    countryWS: 'Samoa',
    countryMP: 'Northern Mariana Islands',
    countryPF: 'French Polynesia',
    countryFM: 'Micronesia (Federated States of)',
    countryMH: 'Marshall Islands',
    countryPW: 'Palau',
    countryAS: 'American Samoa',
    countryGU: 'Guam',
    countryUM: 'United States Minor Outlying Islands',
    countryCC: 'Cocos (Keeling) Islands',
    countryCX: 'Christmas Island',
    countryHM: 'Heard Island and McDonald Islands',
    countryNF: 'Norfolk Island',
    countryCK: 'Cook Islands',
    countryNU: 'Niue',
    countryTK: 'Tokelau',
    countryAQ: 'Antarctica',
    countryBV: 'Bouvet Island',
    countryGS: 'South Georgia and the South Sandwich Islands',
    countryTF: 'French Southern Territories',
  };
  const value = lng[key];
  // return '[' + key + ']';
  return value == null ? '[' + key + ']' : value;
};

export const englishLanguage: LanguageContext = {
  language: 'en',
  translate: translator,
};



// WEBPACK FOOTER //
// ./src/shared/language/English.tsx